import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import ContentInput from "../../components/common/ContentInput";
import MessageDialog from "../../components/common/MessageDialog";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { saveMultiLangData } from "../../store/action";
import i18n from "../../services/i18n";

const SystemCodeManagementEditPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const menuAuthInfo = useMenuAuthInfo();

  const cId = location.state?.id || null;

  const [codeType, setCodeType] = useState("");
  const [code, setCode] = useState("");
  const [descKor, setDescKor] = useState("");
  const [descEng, setDescEng] = useState("");
  const [sbCodeType, setSbCodeType] = useState([]);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpen2, setIsDialogOpen2] = useState(false);

  useEffect(() => {
    loadCodeTypeData();
    loadContentData();
  }, []);

  const loadCodeTypeData = () => {
    api
      .post("/common/codetype", {})
      .then((response) => {
        setSbCodeType([{ code: "", codeDesc: t("L0112") }, ...response.data]);
      })
      .catch(() => {});
  };

  const loadContentData = () => {
    if (cId !== null) {
      api
        .post("/manage/syscode/detail", {
          id: cId,
        })
        .then((response) => {
          if (response.data && response.data.length > 0) {
            setCodeType(response.data[0].type);
            setCode(response.data[0].code);
            setDescKor(
              response.data.filter((item) => item.lang === "KOR")[0].desc
            );
            setDescEng(
              response.data.filter((item) => item.lang === "ENG")[0].desc
            );
          }
        })
        .catch(() => {});
    }
  };

  const handleCodeTypeChange = (e) => {
    setCodeType(e.target.value);
  };

  const handleCodeChange = (e) => {
    setCode(e.target.value.trim());
  };

  const handleDescKorChange = (e) => {
    setDescKor(e.target.value.trim());
  };

  const handleDescEngChange = (e) => {
    setDescEng(e.target.value.trim());
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    if (!validate()) {
      return;
    }

    if (cId === null || cId === "") {
      api
        .post("/manage/syscode/add", {
          type: codeType,
          code: code,
          descKor: descKor,
          descEng: descEng,
          userLang: i18n.language.toUpperCase(),
        })
        .then(() => {
          setIsDialogOpen(true);
          api.post("/common/multilang", {}).then((response) => {
            dispatch(saveMultiLangData(response.data));
          });
        })
        .catch((error) => {
          if (error.response.data.result == "1") {
            setIsDialogOpen2(true);
          }
        });
    } else {
      api
        .post("/manage/syscode/update", {
          type: codeType,
          code: code,
          descKor: descKor,
          descEng: descEng,
          userLang: i18n.language.toUpperCase(),
        })
        .then(() => {
          setIsDialogOpen(true);
          api.post("/common/multilang", {}).then((response) => {
            dispatch(saveMultiLangData(response.data));
          });
        })
        .catch(() => {});
    }
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
    navigate("/manage/systemcode");
  };

  const handleDupConfirm = () => {
    setIsDialogOpen2(false);
  };

  const [errors, setErrors] = useState({
    validCodeType: "",
    validCode: "",
    validEng: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!codeType) {
      tempErrors.validCodeType = "Code Type is required.";
      isValid = false;
    }

    if (!code) {
      tempErrors.validCode = "Code is required.";
      isValid = false;
    }

    if (!descEng) {
      tempErrors.validEng = "English is required.";
      isValid = false;
    }
    setErrors(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0753")]}></BreadCrumbDiv>

      <InputWrapDiv>
        <TopBoxDiv value={t("MENU:L0753")}></TopBoxDiv>

        <table>
          <tbody>
            <tr>
              <th>
                {t("L0112")} *
                {errors.validCodeType && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validCodeType}
                    </span>
                  </>
                )}
              </th>
              <td>
                <CodeSelectBox
                  value={codeType}
                  codes={sbCodeType}
                  onChange={handleCodeTypeChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="96%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                  disabled={cId !== null}
                />
              </td>
            </tr>
            <tr>
              <th>
                {t("L0113")} *
                {errors.validCode && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validCode}
                    </span>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={code}
                  disabled={cId !== null}
                  maxLength={16}
                  onChange={cId === null ? handleCodeChange : undefined}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>{t("KOR")}</th>
              <td>
                <ContentInput
                  value={descKor}
                  maxLength={4000}
                  onChange={handleDescKorChange}
                  disabled={!menuAuthInfo.edit}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("ENG")} *
                {errors.validEng && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validEng}
                    </span>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={descEng}
                  maxLength={4000}
                  onChange={handleDescEngChange}
                  disabled={!menuAuthInfo.edit}
                ></ContentInput>
              </td>
            </tr>
          </tbody>
        </table>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        {menuAuthInfo.edit && (
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          ></FunctionButton>
        )}
        <FunctionButton
          className="big bg_gray"
          value={t("L0005")}
          onClick={handleCancel}
        ></FunctionButton>
      </ButtonWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={t("L0339")} message={t("L0103")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}

      {isDialogOpen2 && (
        <MessageDialog title={t("L0339")} message={t("L0124")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleDupConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default SystemCodeManagementEditPage;
